import { render } from "./ModelsMobile.vue?vue&type=template&id=55cde00f&scoped=true"
import script from "./ModelsMobile.vue?vue&type=script&lang=js"
export * from "./ModelsMobile.vue?vue&type=script&lang=js"

import "./ModelsMobile.vue?vue&type=style&index=0&id=55cde00f&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cde00f"]])

export default __exports__